// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1YpTB","header":"ClearentDisclaimer_header__yHWN2","inner":"ClearentDisclaimer_inner__lJTQk"};